// this should be removed => refactor
import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';
import RadiologyForm from '../RadiologyForm';
import { useDispatch, useSelector } from 'react-redux';
import MessagesContext from '../../../contexts/messagesContext';
import { AlertDialog, MainDialog } from '../../UI';
import { deletePatientReport } from '../../../redux/Reports/ReportsAction';

const RadiologyDialog = (props) => {
    const { messages } = useContext(MessagesContext);
    const form = useSelector((state) => state.reports?.form);
    const reportId = useSelector((state) => state.reports?.form?.reportId);
    const dispatch = useDispatch();
    const handleDelete = async () => {
        await dispatch(deletePatientReport(form.reportId));
        props.handleClose();
    };
    if (props.dialogMode === 'delete') {
        return (
            <AlertDialog
                open={props.openDialog}
                handleClose={props.handleClose}
                alertText={`${messages.alerts.deleteRadiologyHint}
                ${messages.alerts.deleteRadiology}`}
                cancelText={messages.cancel}
                confirmText={messages.delete}
                handleAction={handleDelete}
            />
        );
    } else {
        return (
            <MainDialog
                open={props.openDialog}
                title={reportId ? messages.editRadiology : messages.newRadiology}
                goBack={props.handleClose}
            >
                <RadiologyForm handleClose={props.handleClose} />
            </MainDialog>
        );
    }
};

RadiologyDialog.propTypes = {
    openDialog: PropTypes.bool,
    handleOpen: PropTypes.func,
    handleClose: PropTypes.func,
    dialogMode: PropTypes.func
};
export default RadiologyDialog;
